import { LatLngExpression } from 'leaflet';
import { ReactElement } from 'react';
import { BeamsParams, BeamType, InteractionState, ObjectBeams } from '@dmc/ui';
import { BeamsSVGLayer } from '../beams-svg-layer/BeamsSVGLayer';
import { PositionModelRelative } from '@customer/store/apis/assetsApi';

export interface RelativeInteractionLayerProps {
  position: LatLngExpression;
  heading: number | null;
  relativePosition: PositionModelRelative;
}

function generateFakeTofBeam(relativePosition: PositionModelRelative): BeamsParams {
  return {
    warn: {},
    alarm: {},
    tof: {
      relative: {
        bearing_deg: relativePosition.bg,
        bearingError_deg: relativePosition.bgEr,
        distance_m: relativePosition.rd,
        distanceError_m: relativePosition.rdEr,
      },
    },
  };
}

export const RelativeInteractionLayer = ({
  position,
  heading,
  relativePosition,
}: RelativeInteractionLayerProps): ReactElement | null => {
  const beamsParams = generateFakeTofBeam(relativePosition);
  const hasHeading = typeof heading === 'number';
  const safeHeading = heading ?? 0;

  return (
    // Body config is not needed for TOF/Relative display.
    // We're only representing the approximate location of a DotNetix-detected person to within a quadrant (90 degrees).
    <ObjectBeams bodyWidth={0} bodyLength={0} yRotOfs={0}>
      <BeamsSVGLayer position={position} beamsParams={beamsParams}>
        <ObjectBeams.GroupTransform heading={safeHeading}>
          <ObjectBeams.Beam
            hasHeading={hasHeading}
            beamType={BeamType.ToF}
            beamParams={beamsParams.tof}
            interactionState={InteractionState.None}
          />
        </ObjectBeams.GroupTransform>
      </BeamsSVGLayer>
    </ObjectBeams>
  );
};
